export const FIND_PROCESS_STATEMENT_SUCCESS = 'FIND_PROCESS_STATEMENT_SUCCESS';

export const findProcessStatementSuccess = processStatement => ({
    type: FIND_PROCESS_STATEMENT_SUCCESS,
    payload: { processStatement },
});
